"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.scrollToBottom = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = require("react");
const styled_components_1 = __importDefault(require("styled-components"));
const form_1 = require("../../molecules/form/form");
const textarea_1 = require("../../shared/typography/textarea");
const buttons_1 = require("../../atoms/buttons");
const toggle_1 = require("../../atoms/toggle");
const react_i18next_1 = require("react-i18next");
const moment_1 = __importDefault(require("moment"));
const hooks_1 = require("../../shared/hooks");
const FileInput_1 = require("./FileInput");
const utils_1 = require("./utils");
const PhotoSelected_1 = require("./PhotoSelected");
const Messages_1 = require("./Messages");
const Header_1 = require("./Header");
const Wrapper = styled_components_1.default.div `
  height: 100%;
  max-width: 100vw;
  overflow: auto;
  display: grid;
  grid-template-rows: max-content auto max-content max-content;
  background-color: ${({ theme }) => theme.colors.whiteBase};

  & > div {
    padding-left: 1rem;
    padding-right: 1rem;
  }

  form {
    border-top: 1px solid ${({ theme }) => theme.colors.silverBase};
    margin: 0.25rem 0 0 0;
    padding: ${({ theme }) => theme.spacings.xs};
    svg {
      width: ${({ theme }) => theme.spacings.l};
      height: ${({ theme }) => theme.spacings.l};
    }
    button {
      padding: ${({ theme }) => theme.spacings.xs};
      align-self: flex-end;
      border: none;

      &:disabled {
        background-color: ${({ theme }) => theme.colors.silverLighten70};

        path {
          fill: ${({ theme }) => theme.colors.greyLighten70};
        }
      }
    }

    textarea {
      line-height: 1.5;
      align-self: auto;
      height: unset;
      min-height: 36px;
      margin-right: ${({ theme }) => theme.spacings.xs} !important;
      padding: calc(${({ theme }) => theme.spacings.xxs} + 1px)
        ${({ theme }) => theme.spacings.m};
    }
  }

  label div + h4 {
    font-weight: 400;
  }
`;
const TextareaInvisible = styled_components_1.default.textarea `
  position: fixed;
  left: -100%;
  top: -100%;
  z-index: -1;
`;
const scrollToBottom = (element) => () => {
    if (!element.current)
        return;
    element.current.scrollTop = element.current.scrollHeight || 0;
};
exports.scrollToBottom = scrollToBottom;
const Chat = ({ onMessage, onInputChange, messages, onMarkAsRead, onLoadOld, sendOnEnter, onSendOnEnterChange, unreadMessages = false, initialInputValue = "", onBack, disabled, notification, createMessage, onFileSend, saveFile, getFile, showMarkAsRead = true, isInfinityScroll = false }) => {
    var _a, _b, _c;
    const [t] = (0, react_i18next_1.useTranslation)();
    const { isOffline } = (0, hooks_1.useNetwork)();
    const { isMobile } = (0, hooks_1.useRWD)();
    const messagesContainerRef = (0, react_1.useRef)(null);
    const [rows, setRows] = (0, react_1.useState)(1);
    const [shouldSendOnEnter, setSendOnEnter] = (0, react_1.useState)(sendOnEnter);
    const [input, setInput] = (0, react_1.useState)(initialInputValue);
    const textareaInvisible = (0, react_1.useRef)(null);
    const textArea = (0, react_1.useRef)(null);
    const maxTextareaRows = isMobile ? 6 : 9;
    const messagesContainerHeight = (0, react_1.useRef)();
    const [photo, setPhoto] = (0, react_1.useState)(null);
    const [photoPlaceholder, setPhotoPlaceHolder] = (0, react_1.useState)({ photo: {}, caption: "" });
    const fileInput = (0, react_1.useRef)();
    const [isSendingAttachment, setIsSendingAttachment] = (0, react_1.useState)(false);
    const [temporaryMessages, setTemporaryMessage] = (0, react_1.useState)([]);
    const chatWrapperRef = (0, react_1.useRef)(null);
    const sendMessage = () => {
        if (!input.trim())
            return;
        const msg = createMessage((0, moment_1.default)().format(), input.trim());
        setTemporaryMessage([...temporaryMessages, msg]);
        onMessage(msg);
        setInput("");
        setRows(1);
    };
    const onSubmit = async (e) => {
        e === null || e === void 0 ? void 0 : e.preventDefault();
        if (shouldSendOnEnter && (e === null || e === void 0 ? void 0 : e.shiftKey)) {
            return;
        }
        if (photo) {
            return await sendPhoto();
        }
        sendMessage();
    };
    const onKeyPress = (e) => {
        if (e.charCode === 13 && !isMobile && shouldSendOnEnter && !e.shiftKey) {
            // TODO: TS - type casting due to bad implementation (onKeyPress invoking onSubmit handler...)
            onSubmit(e);
        }
    };
    const onChange = (e) => {
        var _a;
        if (textareaInvisible.current) {
            textareaInvisible.current.value = e.target.value;
            textareaInvisible.current.style.width = `${e.target.clientWidth}px`;
        }
        const scrollHeight = ((_a = textareaInvisible.current) === null || _a === void 0 ? void 0 : _a.scrollHeight) || 0;
        const cloneRows = Math.ceil((scrollHeight - 16) / 24);
        if (cloneRows !== rows) {
            setRows(cloneRows > maxTextareaRows ? maxTextareaRows : cloneRows);
        }
        setInput(e.target.value);
        onInputChange && onInputChange(e.target.value);
        if (rows === maxTextareaRows && textArea.current) {
            textArea.current.scrollTop = textArea.current.scrollHeight;
        }
    };
    const sendPhoto = async () => {
        setIsSendingAttachment(true);
        const { label = "", author } = createMessage((0, moment_1.default)().format(), "");
        const url = await (0, utils_1.readURL)(photo);
        try {
            const { attachment } = await onFileSend(photo, input);
            const msg = await (0, utils_1.createMessageWithAttachment)(url, await (0, utils_1.preRenderImage)(url), label, input, author, attachment);
            setTemporaryMessage([...temporaryMessages, msg]);
            // TODO: TS - type casting due to bad implementation
            setPhotoPlaceHolder(null);
        }
        catch (e) {
            const msg = await (0, utils_1.createMessageWithAttachment)(url, await (0, utils_1.preRenderImage)(url), label, input, author);
            setTemporaryMessage([...temporaryMessages, msg]);
            setPhotoPlaceHolder({ photo: photo, caption: input });
        }
        finally {
            setPhoto(null);
            setInput("");
            setRows(1);
            onInputChange && onInputChange("");
            // TODO: TS - type casting due to bad implementation
            await saveFile(null);
            (0, exports.scrollToBottom)(messagesContainerRef)();
            setIsSendingAttachment(false);
        }
    };
    (0, react_1.useEffect)(() => {
        var _a;
        const getFileAsync = async () => {
            const file = await getFile();
            setPhoto(file);
        };
        getFileAsync();
        const scrollHeight = ((_a = textArea.current) === null || _a === void 0 ? void 0 : _a.scrollHeight) || 0;
        const rows = Math.ceil((scrollHeight - 16) / 24);
        setRows(rows > maxTextareaRows ? maxTextareaRows : rows);
    }, []);
    (0, react_1.useEffect)(() => {
        if (messagesContainerRef.current) {
            messagesContainerRef.current.scrollTop = 0;
        }
    }, [(_a = messages[0]) === null || _a === void 0 ? void 0 : _a.id]);
    (0, react_1.useEffect)(() => {
        var _a, _b;
        if (messagesContainerHeight.current ===
            ((_a = messagesContainerRef.current) === null || _a === void 0 ? void 0 : _a.offsetHeight))
            return;
        (0, exports.scrollToBottom)(messagesContainerRef);
        messagesContainerHeight.current =
            (_b = messagesContainerRef.current) === null || _b === void 0 ? void 0 : _b.offsetHeight;
    }, [messagesContainerHeight.current]);
    (0, react_1.useEffect)(() => {
        (0, exports.scrollToBottom)(messagesContainerRef);
    }, [messages.length > 0, (_b = messages[messages.length - 1]) === null || _b === void 0 ? void 0 : _b.timestamp]);
    (0, react_1.useEffect)(() => {
        setTemporaryMessage([]);
    }, [(_c = messages[messages.length - 1]) === null || _c === void 0 ? void 0 : _c.label]);
    const onRedoClick = (0, react_1.useMemo)(() => async () => {
        const { label, author } = createMessage((0, moment_1.default)().format(), "");
        const url = await (0, utils_1.readURL)(photoPlaceholder.photo);
        try {
            const { id, attachment } = await onFileSend(photoPlaceholder.photo, photoPlaceholder.caption);
            const msg = await (0, utils_1.createMessageWithAttachment)(url, await (0, utils_1.preRenderImage)(url), label || "", photoPlaceholder.caption, author);
            const idx = temporaryMessages.findIndex((msg) => { var _a; return ((_a = msg.attachment) === null || _a === void 0 ? void 0 : _a.sizes.medium.url) === url; });
            temporaryMessages[idx] = {
                ...msg,
                id: id,
                isError: false,
                attachment
            };
            setTemporaryMessage([...temporaryMessages]);
            // TODO: TS - type casting due to bad implementation
            setPhotoPlaceHolder(null);
        }
        catch (e) {
            // ignore error, such message exist
        }
    }, []);
    const handleFileSelect = async (e) => {
        var _a;
        const file = (_a = e.target.files) === null || _a === void 0 ? void 0 : _a[0];
        if (file) {
            setPhoto(file);
            await saveFile(file);
        }
        if (fileInput.current) {
            fileInput.current.value = "";
        }
    };
    const onRemoveSelectedPhoto = async () => {
        if (fileInput.current) {
            fileInput.current.value = "";
        }
        setPhoto(null);
        // TODO: TS - type casting due to bad implementation
        await saveFile(null);
    };
    const isImagesLoaded = (0, react_1.useRef)(false);
    let loadedImages = 0;
    (0, react_1.useEffect)(() => {
        (0, exports.scrollToBottom)(messagesContainerRef)();
    }, [temporaryMessages.length]);
    const onImagesLoad = (imagesToLoad) => (e) => {
        if ((0, Messages_1.isImageEvent)(e)) {
            loadedImages++;
        }
        if (loadedImages === imagesToLoad && !isImagesLoaded.current) {
            (0, exports.scrollToBottom)(messagesContainerRef)();
            isImagesLoaded.current = true;
        }
    };
    const onImageLoad = (e) => {
        if ((0, Messages_1.isImageLoadEvent)(e)) {
            (0, exports.scrollToBottom)(messagesContainerRef)();
        }
    };
    const headerProps = {
        onMarkAsRead: showMarkAsRead && onMarkAsRead ? onMarkAsRead : null,
        onBack: onBack ? onBack : null,
        disabled: isOffline || !unreadMessages
    };
    const handleImageLoad = onImagesLoad((0, utils_1.countMessagesWithAttachment)(messages));
    const previousTopMessageId = (0, react_1.useRef)("");
    const topMessageRef = (0, react_1.useRef)(null);
    const intersectionObserverCallback = (entries) => {
        entries.forEach((entry) => {
            if (entry.isIntersecting) {
                const [firstMessage] = messages;
                previousTopMessageId.current = (firstMessage === null || firstMessage === void 0 ? void 0 : firstMessage.id) || "";
                onLoadOld && onLoadOld();
            }
        });
    };
    (0, react_1.useEffect)(() => {
        var _a;
        const observer = new IntersectionObserver(intersectionObserverCallback, {
            threshold: 0,
            root: messagesContainerRef.current
        });
        if (topMessageRef.current) {
            observer.observe(topMessageRef.current);
        }
        if (previousTopMessageId.current) {
            const ele = (_a = messagesContainerRef.current) === null || _a === void 0 ? void 0 : _a.querySelector(`#m_${previousTopMessageId.current}`);
            ele === null || ele === void 0 ? void 0 : ele.scrollIntoView(true);
        }
        return () => {
            observer.disconnect();
        };
    }, [messages]);
    const useRenderMessage = (0, react_1.useMemo)(() => Messages_1.renderMessage, []);
    return ((0, jsx_runtime_1.jsxs)(Wrapper, { ref: chatWrapperRef, className: "chat-wrapper", children: [(0, jsx_runtime_1.jsx)(Header_1.Header, { ...headerProps }, void 0), (0, jsx_runtime_1.jsxs)(MessagesWrapper, { ref: messagesContainerRef, onLoad: handleImageLoad, onError: handleImageLoad, className: "messagesContainer", children: [!isInfinityScroll && onLoadOld && messages.length > 0 && ((0, jsx_runtime_1.jsx)(buttons_1.Button, { variant: "link", onClick: onLoadOld, children: t("chat.conversation.buttonReadMore") }, void 0)), isInfinityScroll && ((0, jsx_runtime_1.jsx)("div", { ref: topMessageRef }, "top_of_messages_container")), messages.map(useRenderMessage(onRedoClick)), (0, jsx_runtime_1.jsx)("div", { onLoad: onImageLoad, children: temporaryMessages.map(useRenderMessage(onRedoClick)) }, void 0)] }, void 0), notification, !isMobile && ((0, jsx_runtime_1.jsx)(toggle_1.Checkbox, { name: "sendOnEnter", checked: shouldSendOnEnter, label: t("chat.enterKeyCheckbox"), onChange: () => {
                    setSendOnEnter(!shouldSendOnEnter);
                    onSendOnEnterChange && onSendOnEnterChange(!shouldSendOnEnter);
                }, disabled: disabled }, void 0)), (0, jsx_runtime_1.jsxs)(Form, { variant: "horizontal", onSubmit: onSubmit, children: [(0, jsx_runtime_1.jsx)(PhotoSelected_1.PhotoSelected, { photo: photo, onRemovePhoto: onRemoveSelectedPhoto, isSendingAttachment: isSendingAttachment }, void 0), (0, jsx_runtime_1.jsxs)("div", { children: [(0, jsx_runtime_1.jsx)(TextareaInvisible, { rows: 1, ref: textareaInvisible }, void 0), (0, jsx_runtime_1.jsx)(FileInput_1.FileInput, { onChange: handleFileSelect, ref: fileInput }, void 0), (0, jsx_runtime_1.jsx)(textarea_1.Textarea, { ref: textArea, rows: rows, placeholder: t("chat.chatInput.chatInputPlaceholder"), value: input, onKeyPress: onKeyPress, onChange: onChange, disabled: disabled || isSendingAttachment, autoFocus: true }, void 0), (0, jsx_runtime_1.jsx)(buttons_1.Button, { title: t("chat.chatInput.chatInputButtonLabel"), disabled: disabled || isSendingAttachment || (isOffline && !!photo), type: "submit", children: (0, jsx_runtime_1.jsx)("svg", { xmlns: "http://www.w3.org/2000/svg", width: "18", height: "18", viewBox: "0 0 18 18", children: (0, jsx_runtime_1.jsx)("path", { fill: "#fff", fillRule: "evenodd", d: "M17.211 9.894l-15.32 7.66c-.494.247-1.094.047-1.341-.447-.148-.295-.14-.644.02-.933l3.932-7.077c.033-.06.033-.134 0-.194L.57 1.826C.302 1.343.476.734.958.466c.289-.16.638-.168.933-.02l15.32 7.66c.494.247.694.847.447 1.341-.096.194-.253.35-.447.447z" }, void 0) }, void 0) }, void 0)] }, void 0)] }, void 0)] }, void 0));
};
const MessagesWrapper = styled_components_1.default.div `
  padding: 0 1rem 1rem 1rem;
  display: block;
  overflow: auto;

  & > button {
    margin: 0 auto 1rem;
    display: block;
  }
`;
const Form = (0, styled_components_1.default)(form_1.Form) `
  flex-direction: column;
  position: relative;

  & > div:last-of-type {
    display: flex;
    width: 100%;

    & > textarea {
      padding-left: 2rem !important;
    }
  }
`;
exports.default = (0, react_1.memo)(Chat);
//# sourceMappingURL=chat.js.map